import { render } from "./addTitle.vue?vue&type=template&id=347acf5a"
import script from "./addTitle.vue?vue&type=script&lang=js"
export * from "./addTitle.vue?vue&type=script&lang=js"

import "./addTitle.vue?vue&type=style&index=0&id=347acf5a&lang=less"
script.render = render

export default script